import { SettingsMembersAndPermissions, SettingsPageWrapper } from "@shared/ui/Settings";
import { useParams } from "react-router-dom";
import { EntityType } from "@shared/types/commonTypes";

const MembersAndPermissions: React.FC = () => {
  const params = useParams<{ eventOrganizerId: string }>();
  const companyId = params.eventOrganizerId!;
  return (
    <SettingsPageWrapper entityType={EntityType.EVENT} entityId={companyId}>
      <SettingsMembersAndPermissions />
    </SettingsPageWrapper>
  );
};

export default MembersAndPermissions;
